import Status from "@/models/status";
import Arquivo from "@/models/arquivo";

export default class RascunhoItem {
  constructor(id='', texto='', situacao='', dataLimiteRecurso, tipo=null, idItemRelacionado={}, anexos = [], status = null){
    this.id = id;
    this.texto = texto;
    this.situacao = situacao;
    this.dataLimiteRecurso = dataLimiteRecurso;
    this.tipo = new Status(tipo);
    this.idItemRelacionado = idItemRelacionado;
    this.anexos = anexos.map(arq => new Arquivo(arq.id, arq.nome));
    this.status = new Status(status)
  }
}
